module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"profile":"Profile","userSettings":"User Settings","logout":"Logout"}}')
  delete Component.options._Ctor
}
